import { Link } from 'react-router-dom';

const footerLinks = {
  风格分类: [
    { name: '甜美系洛丽塔', path: '/category/tianmei' },
    { name: '哥特洛丽塔', path: '/category/gete' },
    { name: '古典系洛丽塔', path: '/category/gudian' },
  ],
  实用指南: [
    { name: '穿搭技巧', path: '/category/chuanda-jiqiao' },
    { name: '入坑指南', path: '/category/rukeng-zhinan' },
    { name: '品牌推荐', path: '/article/luolita-pinpai-quangonglve' },
  ],
  关于我们: [
    { name: '品牌介绍', path: '/about' },
    { name: '联系我们', path: '/about' },
    { name: '隐私政策', path: '/about' },
  ],
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="container-custom py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-foreground-800 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-vip-crown-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-semibold whitespace-nowrap">
                洛丽塔风格指南
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              专注于洛丽塔时尚文化的原创内容平台，为每一位热爱洛丽塔的女孩提供最温暖的风格指南。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="container-custom py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 洛丽塔风格指南. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}